import { IAppState } from '../../../AppModulesWrapper';

import { selectIsInsufficientFunds } from '../checkoutInfo';

import { EMoneySource } from '../../types/reducers/user';
import { selectPlacingMoneySource } from '../../reducers/v2/moneySources/selectors';
import { selectIsSubagent } from '../../reducers/v2/user/selectors';

export const selectIsSubagentMasterAccountMoneyLimitExceeded = (state: IAppState): boolean => {
  const isSubagent = selectIsSubagent(state);

  if (!isSubagent) {
    return false;
  }

  const notEnoughMoney = selectIsInsufficientFunds(state);
  const placingMoneySource = selectPlacingMoneySource(state);
  const placingFromMasterAccount = placingMoneySource === EMoneySource.Master;

  return notEnoughMoney && placingFromMasterAccount;
};
